import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Card, Select } from 'antd';

interface MonthlyTotal {
  _id: {
    month: number;
    year: number;
  }

  totalBorrowedAmount: number;
  totalPaidAmount: number;
}

interface ChartComponentProps {
  monthlyTotals: MonthlyTotal[];
  selectedYear: number;
  onYearChange: (year: number) => void;
}

const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const MonthlyCharts: React.FC<ChartComponentProps> = ({ monthlyTotals, selectedYear, onYearChange }) => {

  // Filter data by selected year
  const filteredData = monthlyTotals.filter(item => item._id.year === selectedYear);

  const dataForMonths = Array.from({ length: 12 }, () => 0)
  const dataForMonthsPaid = Array.from({ length: 12 }, () => 0)

  filteredData.forEach((item) => {
    const monthIndex = item._id.month - 1
    dataForMonths[monthIndex] = item.totalBorrowedAmount;
  })

  filteredData.forEach((item) => {
    const monthIndex = item._id.month - 1
    dataForMonthsPaid[monthIndex] = item.totalPaidAmount
  })

  // Generate year options dynamically from available data
  const availableYears = Array.from(
    new Set(monthlyTotals.map(item => item._id.year))
  ).sort((a, b) => b - a);

  const yearOptions = availableYears.map(year => ({
    label: year.toString(),
    value: year
  }));

  const options = {
    chart: {
      type: 'column'
    },
    colors: ['#0062ff','#33b559', '#ff9466', '#fe5e37'],

    title: {
      text: null
    },
    legend: {
    align: 'left',
    verticalAlign: 'top',
    layout: 'horizontal',
    itemStyle: {
      fontWeight: 'normal'
    }
  },
    xAxis: {
      categories: MONTH_NAMES,
      crosshair: true,
      accessibility: {
        description: 'Months'
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Amount (UGX)'
      }
    },
    tooltip: {
      shared: true
    },
    series: [
      {
        name: 'Amount Borrowed',
        data: dataForMonths
      },
      {
        name: 'Amount Paid',
        data: dataForMonthsPaid
      }
    ],
    credits: {
            enabled: false
          }
  };

  return (
    <Card style={{border: '1px #00000022 solid'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16}}>
        <h3 className='text-uppercase font-weight-bold' style={{fontSize: '15px', fontWeight: 'bold', margin: 0}}>
          Loan issuance and payment analytics
        </h3>
        <Select
          value={selectedYear}
          onChange={onYearChange}
          options={yearOptions}
          style={{ width: 120 }}
          placeholder="Select Year"
        />
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
};

export default MonthlyCharts
